import { useState } from 'react';

export default function useTireLifeInfo() {
  const [miles, setMiles] = useState(15);
  const [milesInputError, setMilesInputError] = useState({
    hasErrors: false,
    message: ''
  });

  function onMilesInputChange(e) {
    const miles = parseInt(e?.target?.value);

    if (!miles || miles < 5 || miles > 55)
      setMilesInputError({
        hasErrors: true,
        message: 'Please enter a whole number from 5 - 55'
      });

    if (miles > 4 && miles < 56) {
      setMiles(miles);
      setMilesInputError({
        hasErrors: false,
        message: ''
      });
    }
  }

  function onMilesInputBlur(e) {
    const miles = parseInt(e?.target?.value);

    if (!miles || miles < 5) setMiles(5);
    if (miles > 55) setMiles(55);

    setMilesInputError({
      hasErrors: false,
      message: ''
    });
  }

  return {
    miles,
    milesInputError,
    onMilesInputBlur,
    onMilesInputChange,
    setMiles
  };
}
